/////////////// LIB. ///////////////
////////////////////////////////////

// ...

////////////// UTIL. ///////////////
////////////////////////////////////

// ...

////////// EVENT HANDLERS //////////
////////////////////////////////////

// ...

////////////// ASSETS //////////////
////////////////////////////////////

const logArgs = { eventName: "init_projectData", inline: true, disabled: false };
const msgs = {
  start: ["init. projectData"],
  end: ["init. projectData", "init. success"],
  no_el: ["init. projectData", "no valid DOM el. provided"],
  req_failed: (req) => [`init. projectData`, `failed to fetch project data: ${req.status} ${req.statusText}`],
};

//////// INIT. METHOD DEF. /////////
////////////////////////////////////

export default async function init_projectData() {
  ////////////// Setup ///////////////
  ////////////////////////////////////

  const { donationProgressBar, display_donationAmount, projectImg } = this.ref;
  const { projectId, donationGoal } = this.options;
  this.logger("init", msgs.start, "action", logArgs);

  // console.log("BetterplaceIntegration: Initializing project data for project ID:", projectId);
  // console.log("BetterplaceIntegration: Donation goal is set to:", donationGoal);

  ////////////// ACTION //////////////
  ////////////////////////////////////

  // Fetch betterplace project data
  const req = await fetch(`https://api.betterplace.org/de/api_v4/projects/${projectId}.json`);
  if (!req.ok) return this.logger("init", msgs.req_failed(req), "error", logArgs);

  // Format incoming data
  const data = await req.json();
  // console.log("BetterplaceIntegration: Fetched project data:", data);

  // Updt. donation progress bar
  const { donated_amount_in_cents } = data;
  const donatedAmount = donated_amount_in_cents / 100;
  const progressPercent = ((donatedAmount / donationGoal) * 100).toFixed(2);
  donationProgressBar.style.setProperty("--prog", `${progressPercent}%`);
  display_donationAmount.textContent = `${donatedAmount}€`;

  // Updt. project img. src.
  // const { profile_picture } = data || null;
  // const profile_picture_links = profile_picture ? profile_picture.links : null;
  // const projectImgUrl = profile_picture_links ? profile_picture_links.find((link) => link.rel === "original")?.href : null;
  // if (projectImgUrl) projectImg.src = projectImgUrl;

  ///////////// Conclude /////////////
  ////////////////////////////////////

  this.logger("init", msgs.end, "success", logArgs);
}
